import * as ko from "knockout";
import * as Global from "../common/global";
import * as UI from "../common/ui";
import * as Util from "../common/util";
import * as AuthenticationData from "../data/authenticationData";
import { IApplication } from "../interfaces/application";
import { IController } from "../interfaces/controller";
import * as Data from "../interfaces/data";

export class ForgotPasswordController implements IController {
    // constants

    // private properties
    private container: JQuery;
    private viewModel: any = {};

    // constructors
    constructor() {
        const me: ForgotPasswordController = this;

        this.viewModel = {
            // forgot password fields
            UserIdentification: ko.observable(""),
            UserIdentificationMissing: ko.observable(false),
            Success: ko.observable(false),

            LoginHelp: ko.observable(""),

            onForgotPassword(e: JQueryEventObject): void {
                me.processPasswordRequest();
            },
            onGotoHomePage(e: JQueryEventObject): void {
                const app: IApplication = Global.app();
                app.pageManager().closeCurrentPage();
            },
        };

        this.viewModel.hasLoginHelp = ko.pureComputed((): boolean => {
            return !Util.isNullOrEmpty(me.viewModel.LoginHelp());
        });
    }

    // public Methods

    public render(container: JQuery): JQuery.Promise<any, any, any> {
        const me: ForgotPasswordController = this;
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();

        this.container = container;
        ko.applyBindings(this.viewModel, container[0]);

        // process if user presses enter while in the email field
        this.container.find("input[data-id='emailField']").keypress((e: any) => {
            if (e.which === 13) {
                $(e.target).blur();
                me.processPasswordRequest();
            }
        });

        deferred.resolve();
        return deferred.promise();
    }

    public load(params: any[]): JQueryPromise<any> {
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();

        this.viewModel.UserIdentification("");
        this.viewModel.UserIdentificationMissing(false);
        this.viewModel.Success(false);
        // this.viewModel.LoginHelp(app.global.LoginHelp);

        this.container.find("input").first().focus();

        deferred.resolve();
        return deferred.promise();
    }

    public haveFieldsChanged(): boolean {
        return false;
    }

    public appRouterID(params: any[]): string {
        return "ForgotPassword";
    }

    public title(): string {
        return "Forgot Password";
    }

    public subTitle(): string {
        return "";
    }
    public AllowAnonymousAccess(): boolean {
        return true;
    }

    private processPasswordRequest(): void {
        const me: ForgotPasswordController = this;
        let waitContainer: JQuery<HTMLElement>;
        let request: AuthenticationData.IEmailPasswordResetRequest;

        if (!this.validatePaswordReset()) {
            return;
        }

        waitContainer = UI.showWaitIndicator(this.container);

        request = {
            UserIdentification: this.viewModel.UserIdentification(),
        };
        AuthenticationData.EmailPasswordReset(request)
            .done((response: Data.IResponse<string>) => {
                if (response.Success) {
                    me.viewModel.Success(true);
                } else {
                    UI.showErrorMessage(response.ErrorMessages);
                }
            })
            .always(() => {
                UI.hideWaitIndicator(me.container, waitContainer);
            });

    }

    private validatePaswordReset(): boolean {
        let isValid: boolean = true;

        isValid = UI.setRequiredStringError(this.viewModel.UserIdentification(),
            "UserIdentificationMissing", this.viewModel) ? isValid : false;

        return isValid;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/controllers/forgotPassword.ts